import styled, { Utils } from '@nfinite/react-hubstairs/styled'

import { Button as ButtonHubstairs } from '@nfinite/react-hubstairs/components'

export const StyledButtonHubstairs = styled(ButtonHubstairs)`
  ${Utils.generateScaleRollhover({ fit: false })}
`
StyledButtonHubstairs.Placeholder = styled(StyledButtonHubstairs)`
  color: transparent;
  background-color: transparent;
  border: none;
  cursor: default;
  &:hover {
    background-color: transparent;
  }
  &:active {
    box-shadow: none;
    background-color: transparent;
    border: none;
  }
`
